'use client';

import Link from 'next/link';
import { useParams } from 'next/navigation';
import { MainLayout } from '@/components/layout/MainLayout';
import { PlatformGuidePage } from '@/components/guides/PlatformGuidePage';
import { GUIDE_AUDIENCE_ORDER, isGuideAudience } from '@/config/platform-guides';

export default function GuideAudiencePage() {
  const params = useParams();
  const audienceParam = typeof params?.audience === 'string' ? params.audience : '';

  if (!isGuideAudience(audienceParam)) {
    return (
      <MainLayout>
        <div className="mx-auto max-w-xl px-4 py-24 text-center">
          <h1 className="text-2xl font-bold text-landing-text">Guide not found</h1>
          <p className="mt-2 text-sm text-landing-muted">Choose one of the available platform guides below.</p>
          <div className="mt-6 flex flex-wrap justify-center gap-3">
            {GUIDE_AUDIENCE_ORDER.map((audience) => (
              <Link
                key={audience}
                href={`/guides/${audience}`}
                className="rounded-full bg-landing-primary px-4 py-2 text-sm font-semibold text-text-inverse"
              >
                {audience}
              </Link>
            ))}
          </div>
        </div>
      </MainLayout>
    );
  }

  return <PlatformGuidePage audience={audienceParam} />;
}
